export const PERSISTENT_STORAGE_KEY = 'platform-group/irwin/market-cap-definitions'
export const MARKET_CAP_ERROR_FIELD = 'market_cap(s)'
